<template>
  <form
    :id="formId"
    class="mt-3"
    accept-charset="UTF-8"
    @submit.prevent="submit"
  >
    <div class="form-group">
      <label
        class="gf-counted-input mb-0"
        for="repoName"
        :data-current-length="formData.title?.length + ' / 100'"
      >
        <span class="font-weight-bolder">
          {{ $tc('message.title', 3, { obj: $t('project_choose') }) }}
        </span>
        <input
          type="text"
          name="title"
          class="form-control form-control-sm mt-2"
          id="repoName"
          aria-describedby="repoNameHelp"
          v-model="formData.title"
          minlength="1"
          maxlength="100"
          :class="{ 'is-invalid': formErrors && formErrors.title }"
        />
      </label>
      <div
        v-if="formErrors && formErrors.title"
        class="invalid-feedback d-flex"
      >
        {{ formErrors.title }}
      </div>
    </div>
    <div class="form-group">
      <label
        class="font-weight-bolder"
        for="repoDescription"
      >
        {{ $tc('message.description', 2, { obj: $t('project_choose') }) }}
      </label>
      <gf-custom-text-editor
        v-model="formData.description"
        :value="formData?.description"
        saved-data-type="text"
        :placeholder="$t('project_describe')"
        :has-action-buttons="false"
        :max-length="600"
        :hasError="formErrors && formErrors.description"
        :error-text="formErrors?.description"
        :autofocus="false"
      ></gf-custom-text-editor>
    </div>
    <div class="form-group">
      <label
        class="font-weight-bolder"
        for="repoSiteUrl"
      >
        {{ $t('project_website') }}
      </label>
      <input
        id="repoSiteUrl"
        v-model="formData.url"
        aria-describedby="repoNameHelp"
        class="form-control form-control-sm"
        name="url"
        type="text"
        :class="{ 'is-invalid': formErrors && formErrors.url }"
      />
      <div
          v-if="formErrors && formErrors.url"
          class="invalid-feedback d-flex"
      >
        {{ formErrors.url }}
      </div>
    </div>
    <div class="form-group">
      <label class="font-weight-bolder">
        {{ $tc('language', 1) }}
      </label>
      <custom-select
        v-model="formData.language"
        :options="langOptions.items"
        :placeholder="$tc('language', 2)"
        :searchable="true"
        @search="searchLangs"
        @open="getLangsList"
      >
        <custom-selector-dot-option
          slot-scope="{ option }"
          :hex-color="option.color"
          :option="option"
        ></custom-selector-dot-option>
      </custom-select>
    </div>

    <div class="form-group">
      <label
        for="topics"
        class="font-weight-bolder"
      >
        Топики
      </label>
      <project-topic-selector
        :user-alias="alias"
        :project-alias="projectAlias"
        @input="inputHandler"
      />
    </div>
  </form>
</template>

<script>
import referenceService from '../../services/reference.service.js';
// import repoService from '../../../services/repository.service.js';
import repoService from '@/shared-modules/services/repository.service.js';
import CustomSelect from '@shared/shared-components/shared/custom-select';
import CustomSelectorDotOption from '@/shared-modules/shared-components/shared/custom-selector-dot-option.vue';
import { FORM_NAME_ENUMS } from '@shared/variables/form-name.enums';
import sharedComponentsMessages from '@/shared-modules/shared-components/sharedComponentsMessages';
import GfCustomTextEditor from '@shared/shared-components/shared/GfCustomTextEditor';

export default {
  name: 'ProjectBasicSettingsForm',
  components: {
    CustomSelectorDotOption,
    CustomSelect,
    GfCustomTextEditor
  },
  props: {
    project: { default: {} },
    formId: { default: '' },
    isOpened: { default: false }
  },
  data() {
    return { langOptions: {}, formData: {} };
  },
  mounted() {
    this.formData = { ...this.project.projectData };
  },
  computed: {
    formErrors() {
      return this.$store.getters.getFormErrors(FORM_NAME_ENUMS.PROJECT_BASE_SETTING_FORM);
    },
    alias() {
      return this.$route.params.alias;
    },
    projectAlias() {
      return this.$route.params.projectAlias;
    }
  },
  methods: {
    searchLangs($event) {
      referenceService
        .getLangs({
          q: $event,
          size: 50
        })
        .then((res) => {
          this.langOptions = { ...res };
        });
    },
    inputHandler(data) {
      this.formData.topics = Array.isArray(data)
        ? data.map((topic) => (typeof topic === 'object' && topic.title ? topic.title : topic))
        : [];
    },
    submit() {
      repoService
        .editRepository(this.project.alias, this.project.projectAlias, {
          ...this.formData,
          language: this.formData.language.id
        })
        .then(() => {
          window.location.reload();
        })
        .catch((err) => {
          console.log(err);
        });
    },
    getLangsList() {
      referenceService.getLangs({ size: 50 }).then((res) => {
        this.langOptions = { ...res };
      });
    }
  },
  i18n: {
    messages: sharedComponentsMessages
  }
};
</script>

<style lang="scss"></style>
